import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faLongArrowAltRight,
  faLongArrowAltLeft,
  faInfoCircle
} from '@fortawesome/free-solid-svg-icons';

const MosMessageRow = styled.tr`
  display: table-row;
  width: 100%;
  height: 1rem;

  &:nth-child(even) {
    background: #eeeeee;
  }
`;

const Cell = styled.td`
  width: ${props => props.width || 'auto'};
  padding: 0.1rem 0.2rem;
  vertical-align: top;
`;

class MosMessage extends PureComponent {
  getTypeIcon = type => {
    switch (type) {
      case 'out':
        return <FontAwesomeIcon icon={faLongArrowAltRight} size="lg" color="green" fixedWidth />;
      case 'in':
        return <FontAwesomeIcon icon={faLongArrowAltLeft} size="lg" fixedWidth />;
      case 'log':
        return <FontAwesomeIcon icon={faInfoCircle} size="sm" color="#0000A0" fixedWidth />;
      default:
        return type;
    }
  };

  formatTimestamp = ts => moment(ts).format('hh:mm:ss');

  render() {
    const { type, content, timestamp } = this.props;
    return (
      <MosMessageRow>
        <Cell>{this.formatTimestamp(timestamp)}</Cell>
        <Cell>{this.getTypeIcon(type)}</Cell>
        <Cell width="100%">{content}</Cell>
      </MosMessageRow>
    );
  }
}

MosMessage.propTypes = {
  type: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  timestamp: PropTypes.number.isRequired
};

export default MosMessage;



// WEBPACK FOOTER //
// ./app/components/Test/ContainerTest/MosMessage.js